const INTERNAL_ID_FIELD = '_internalId';

export const getRowId = (row: any): string | number => {
  return row[INTERNAL_ID_FIELD];
};

/**
 * adds internal ID based on the result-index to be used by the data-grid
 * to accommodate for duplicated entity IDs
 * @param rows
 * @param startIndex
 */
export const addInternalRowIds = (rows: any[], startIndex = 0) => {
  return rows.map((row, i) => ({ ...row, [INTERNAL_ID_FIELD]: i + startIndex }));
};
